import { FC, useEffect } from 'react';
import { PlayerMeta, Team } from '../../../types';
import { CbParticipantPickerContainer } from './CbParticipantPickerContainer';
import { CbParticipantTeamPickerContainer } from './CbParticipantTeamPickerContainer';
export interface CbParticipantPickerProps {
  edit?: boolean;
  typeOfSearch: string;
  players: PlayerMeta[];
  teams: Team[];
  selectedParticipants: any[];
  hideSelectAllButton?: boolean;
  showNotificationSettings?: boolean;
  customTeamTitle?: string;
  customTeamTitleColor?: string;
  saveselectedParticipants: (player: PlayerMeta[], teams: Team[], current: string) => void;
  setTextFilter: (query: string) => void;
  setTeamIds: (filter: number[] | null) => void;
  handlePrimarySelected?: (id: number, notificationsEnabled: boolean, participantId?: string | number) => Promise<void> | any;
  hideTabs?: boolean;
  maxHeight?: string;
  teamId?: number;
}
export const CbParticipantPicker: FC<CbParticipantPickerProps> = ({
  edit,
  typeOfSearch,
  players,
  teams,
  hideSelectAllButton,
  showNotificationSettings,
  customTeamTitle,
  customTeamTitleColor,
  selectedParticipants,
  saveselectedParticipants,
  setTextFilter,
  setTeamIds,
  handlePrimarySelected,
  hideTabs = false,
  maxHeight = '',
  teamId
}) => {
  const handleSort = (list: any[]): any[] => {
    list.sort((a, b) => {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });
    return list;
  };
  useEffect(() => {
    if (!edit) {
      saveselectedParticipants([], [], 'clear');
    }
  }, [typeOfSearch]);
  return <>
      {typeOfSearch === 'individual' && <CbParticipantPickerContainer typeOfSearch={typeOfSearch} players={players} teams={teams} showNotificationSettings={showNotificationSettings} selectedParticipants={selectedParticipants} teamId={teamId} saveselectedParticipants={saveselectedParticipants} setTextFilter={setTextFilter} setTeamIds={setTeamIds} handleSort={handleSort} hideTabs={hideTabs} maxHeight={maxHeight} handlePrimarySelected={handlePrimarySelected} />}
      {typeOfSearch === 'team' && <CbParticipantTeamPickerContainer hideButton={hideSelectAllButton} showNotificationSettings={showNotificationSettings} customTeamTitle={customTeamTitle} customTeamTitleColor={customTeamTitleColor} teams={teams} typeOfSearch={typeOfSearch} selectedParticipants={selectedParticipants} saveselectedParticipants={saveselectedParticipants} handleSort={handleSort} maxHeight={maxHeight} handlePrimarySelected={handlePrimarySelected} />}
    </>;
};